<template>
    <div>
        <div class="common-header">
            <el-button type="primary" plain @click="$emit('my-close')">返回</el-button>
            <div class="common-header-right">
                <div class="common-header-block">
                    <el-button type="primary" @click="getList()">搜索</el-button>
                    <el-button v-if="permissions.osm_room_info_export" type="success" @click="exportFunc">导出</el-button>
                </div>
            </div>
        </div>
        <div class="common-table">
            <el-table
                    v-loading="loading"
                    :data="batchUserStatsInner.beanList"
                    :row-key="row=>JSON.stringify(row)"
                    height="100%">
                <el-table-column label="编号" type="index" align="center"/>
                <el-table-column label="俱乐部号" align="center" prop="clubRandomId"/>
                <el-table-column label="俱乐部名称" width="150" align="center" prop="clubName"/>
                <el-table-column label="用户ID" align="center" prop="userRandomId"/>
                <el-table-column label="用户昵称" align="center" prop="userNickname"/>
                <el-table-column label="房间ID" align="center" prop="roomId"/>
                <el-table-column label="房间名称" align="center" prop="roomName"/>
                <el-table-column label="JP击中" width="150" align="center">
                    <template slot-scope="scope">{{scope.row.jpPl|numberChip}} 记分牌</template>
                </el-table-column>
                <el-table-column label="JP贡献" align="center" prop="jp">
                  <template slot-scope="scope">{{scope.row.jp|numberChip}}</template>
                </el-table-column>
                <el-table-column label="保险池" align="center" prop="insurancePool">
                  <template slot-scope="scope">{{scope.row.insurancePool|numberChip}}</template>
                </el-table-column>
                <el-table-column label="总带入" align="center" prop="bring">
                  <template slot-scope="scope">{{scope.row.bring|numberChip}}</template>
                </el-table-column>
                <el-table-column label="手数" align="center" prop="hand"/>
                <el-table-column label="盈亏" align="center" prop="integral">
                  <template slot-scope="scope">{{scope.row.integral|numberChip}}</template>
                </el-table-column>
                <el-table-column label="系数盈亏" align="center" prop="coefficientIntegral">
                  <template slot-scope="scope">{{scope.row.coefficientIntegral|numberChip}}</template>
                </el-table-column>
                <el-table-column label="大小盲" align="center" prop="blind">
                  <template slot-scope="scope">{{scope.row.blind|blindNoteNumber}}</template>
                </el-table-column>
                <el-table-column label="结束时间" align="center" prop="endTime"/>
                <el-table-column label="是否开启保险" width="150" align="center">
                    <template slot-scope="scope">{{scope.row.insurance?'是':'否'}}</template>
                </el-table-column>
            </el-table>
        </div>

        <el-pagination
                class="common-el-pagination"
                layout="prev,pager,next,jumper"
                background
                :page-size="20"
                :pager-count="5"
                :total="batchUserStatsInner.total"
                :current-page="currentPage"
                @current-change="getList($event)"/>
    </div>
</template>
<script>
    import {mapState, mapMutations, mapActions} from 'vuex'

    export default {
        props: {
            userId: [String, Number],
            coefficient: [String, Number],
            date: [Array, String]
        },
        data() {
            return {
                loading: false,
                currentPage: 1
            }
        },
        computed: {
            ...mapState('login', ['permissions']),
            ...mapState('gameDetail', ['batchUserStatsInner']),
        },
        created() {
            this.getList()
        },
        methods: {
            ...mapMutations('other', ['setStateDownloadConfig']),
            ...mapActions('gameDetail', ['getBatchUserStatsInner']),
            getList(page = 1) {
                this.loading = true;
                this.currentPage = page;
                this.getBatchUserStatsInner({
                    userId: this.userId,
                    coefficient: this.coefficient,
                    startTime: this.date[0],
                    endTime: this.date[1],
                    page
                }).then(() => {
                    this.loading = false;
                })
            },
            exportFunc() {
                this.setStateDownloadConfig({
                    action: '/gameDetail/batch/user/stats/inner/export',
                    info: [
                        {name: 'userId', value: this.userId},
                        {name: 'coefficient', value: this.coefficient},
                        {name: 'startTime', value: this.date[0]},
                        {name: 'endTime', value: this.date[1]}
                    ]
                })
            }
        }
    }
</script>